import { FormInstance } from "antd";
import { useNotification } from "providers";
import { FC, useRef, useState } from "react";
import { AppButton, Form, FORM_FIELD_TYPES, IFormItems } from "site/ui";
import styled from "styled-components";

const SectionTitle = styled.h2`
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #5575f7;
`;


const FormWrapper = styled.div`
  margin-bottom: 30px;
`;
const signInFormItems:IFormItems[] = [
  // {
  //   itemProps: {
  //     label: "Email",
  //     name: "email",
  //   },
  //   fieldType: FORM_FIELD_TYPES.TEXT,
  //   fieldProps: {
  //     placeholder: "Email address",
  //     value: "escobar@persona.art",
  //     readOnly: true,
  //   },
  // },
  {
    itemProps: {
      label: "Old Password",
      name: "old_password",
    },
    fieldType: FORM_FIELD_TYPES.PASSWORD,
    fieldProps: {
      placeholder: "Old password",
      size: "large",
    },
  },
  {
    itemProps: {
      label: "Password",
      name: "password",
    },
    fieldType: FORM_FIELD_TYPES.PASSWORD,
    fieldProps: {
      placeholder: "New password",
      size: "large",
    },
  },
  {
    itemProps: {
      label: "Confirm password",
      name: "confirm_password",
    },
    fieldType: FORM_FIELD_TYPES.PASSWORD,
    fieldProps: {
      placeholder: "Confirm password",
      size: "large",
    },
  },
];
interface IFormData {
    // email: string;
    old_password: string;
    password: string;
    confirm_password: string;
}
export interface SignIinSettingProps {
    onChangePassword: (data: {
        // email: string;
        oldPassword:string;
        password: string
    }) => Promise<boolean>;
}
export const  SignInSetting:FC<SignIinSettingProps> = ({
    onChangePassword
}) => {
    const formRef = useRef<FormInstance<IFormData>>(null);
    const [loading, setLoading] = useState(false);
    const notification = useNotification();
    return (
      <div>
        <SectionTitle>Sign in preferences</SectionTitle>
        <FormWrapper>
          <Form
            formRef={formRef}
            formProps={{
              layout: "vertical",
              style: { padding: 0 },
            }}
            items={signInFormItems}
          />
        </FormWrapper>
        <AppButton variant="primary" loading={loading} onClick={() => {
            (async () => {
                try{
                    const data = await formRef.current?.validateFields()
                    if(data){
                      if(data.password !== data.confirm_password){
                        notification.error({
                          message: "Password and confirm password doesn't match"
                        })
                        return;
                      }
                      setLoading(true);
                        onChangePassword({
                            // email: data.email,
                            oldPassword: data.old_password,
                            password: data.password
                        }).then(result => {
                            if(result){
                                formRef.current?.resetFields()
                            }
                        }).finally(() => setLoading(false))
                    }
                }catch(e){}
            })()
        }}>Save</AppButton>
      </div>
    );
  };